<template>
  <right-long-banner-template :title="title">
    <div class="search-box">
      <div style="position: relative;">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input class="main-search" type="text" @input="onInput" @keydown.enter="onEnter" :value="keyword">
      </div>
      <div class="filter-field" v-if="$store.state.lang === 'vn'">
        <p>Chuyên mục</p>
        <select v-model="filterType">
          <option value="all" selected>Tất cả</option>
          <option value="news">Tin tức</option>
          <option value="training">Dịch vụ huấn luyện</option>
          <option value="admission">Tuyển sinh</option>
        </select>
      </div>

      <div class="filter-field" v-else>
        <p>Section</p>
        <select v-model="filterType">
          <option value="all" selected>All</option>
          <option value="news">News</option>
          <option value="training">Training Service</option>
          <option value="admission">Admission</option>
        </select>
      </div>
    </div>

    <div class="news-content" v-if="!isLoading">
      <div v-for="(content, index) in visibleArticles" :key="index">
        <div class="box" v-if="!content.hidden">
          <p>{{ formatDate(content.date || content.createdAt) }}</p>
          <router-link id="title" v-if="!content.subMenus" :to="{ name: content.routeName || simpleRoute, params: { url: content.url }}">{{ content.title || content.name }}</router-link>
          <a v-else id="special-title" @click.prevent="toggleSub(index)">{{ content.name }}</a>
          <div class="news-box">
            <img @contextmenu.prevent :src="cacheBuster(content.img)" v-if="!content.subMenus" @click="routeDetail(content.routeName ,content.url)">
            <img @contextmenu.prevent :src="cacheBuster(content.img)" v-else @click.prevent="toggleSub(index)">
            <div class="info">
              <div v-show="activeSub === index && content.subMenus" class="drop-down">
                <div class="sub-menu">
                  <div class="sub-link" v-for="(sub, i) in filterSubMenus3(content.id)" :key="i">
                    <li>
                      <router-link :to="{ name: sub.routeName, params: { url: sub.url } }">{{ sub.name }}</router-link>
                    </li>
                  </div>
                </div>
              </div>

              <p id="summary">{{ content.summary }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="more-content">
        <button v-if="visibleCount < getArticle.length" @click="showMore" class="btn-more">
          {{ moreText }}
        </button>
      </div>

      <!-- <div class="pagination">
        <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
        <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
        <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
        <div style="color: #ffffff; background: #0298cf;">{{ currentPage }}</div>
        <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
        <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
        <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
      </div> -->
    </div>
  </right-long-banner-template>
</template>

<script>
export default {
  props: ['keyword', 'title'],
  data () {
    return {
      searchData: '',
      filterType: 'all',
      simpleRoute: '',
      searchTerm: this.keyword.toLowerCase(),
      visibleCount: 5,
      activeSub: null,
      preSearch: null,
      isLoading: false
    }
  },
  computed: {
    // getMenuInfo () {
    //   return this.$store.getters['navbar/finalMenu'][1]
    // },
    // getNews () {
    //   return this.$store.getters['news/finalNews']
    // },
    // paginatedData () {
    //   const start = (this.currentPage - 1) * this.pageSize
    //   const end = start + this.pageSize
    //   return this.getNews.slice(start, end)
    // },
    // totalPages () {
    //   const tp = Math.ceil(this.getNews.length / this.pageSize)
    //   if (tp === 0) return 1
    //   return tp
    // },
    moreText () {
      if (this.$store.state.lang === 'vn') return 'Xem thêm'
      else return 'See more'
    },
    getArticle () {
      const news = this.$store.getters['news/searchSectionNews']
      const updatedNews = news.map(item => ({
        ...item, // Spread the original news item properties
        routeName: 'NewsDetail' // Add the routeName property
      }))

      const admission = this.$store.getters['recruit/getFrontendAdmissions']
      const updatedAdmission = admission.map(item => ({
        ...item, // Spread the original news item properties
        routeName: 'SPDetail' // Add the routeName property
      }))

      const trainingService = this.$store.getters['services/getFrontendTS']
      // eslint-disable-next-line
      let article = []

      if (this.filterType === 'all') {
        article = [...updatedNews, ...trainingService, ...updatedAdmission]
      } else if (this.filterType === 'news') {
        article = updatedNews
      } else if (this.filterType === 'training') {
        article = trainingService
      } else if (this.filterType === 'admission') {
        article = updatedAdmission
      }

      // article.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      article.sort((a, b) => {
        const dateA = a.date ? new Date(a.date) : new Date(a.createdAt)
        const dateB = b.date ? new Date(b.date) : new Date(b.createdAt)

        return dateB - dateA // Latest first
      })

      return article
    },
    visibleArticles () {
      // Return only the articles that should be visible
      return this.getArticle.slice(0, this.visibleCount)
    }
  },
  methods: {
    onInput (event) {
      this.searchData = event.target.value // Update the value manually
    },
    async getSearchData () {
      this.isLoading = true
      await this.$store.dispatch('news/getNewsByFilters', { filterQuery: this.searchData.toLowerCase() })
      await this.$store.dispatch('services/getTSByFilter', { filterQuery: this.$route.query.input.toLowerCase() })
      await this.$store.dispatch('recruit/getAdmissionsByFilter', { filterQuery: this.searchData.toLowerCase() })
      const data = this.$store.getters['services/getFrontendTS'].filter(item => item.subMenus === true).map(item => item.id)
      if (data.length > 0) {
        await this.$store.dispatch('services/getTSDetailForPages', { ids: data })
      }
      this.isLoading = false
    },
    routeDetail (routeName, url) {
      this.$router.push({ name: routeName, params: { url } })
    },
    // changePage (page) {
    //   if (page >= 1 && page <= this.totalPages) {
    //     this.currentPage = page
    //   }
    // },
    cacheBuster (url) {
      return `${url}?cacheBuster=${new Date().getTime()}`
    },
    formatDate (idate) {
      const date = new Date(idate)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },
    async onEnter () {
      if (!this.searchData || this.preSearch === this.searchData) {
        return
      }

      this.$router.push({
        name: 'searchPage',
        query: { input: this.searchData }
      })
      await this.getSearchData()
      this.visibleCount = 5
      this.preSearch = this.searchData
      // this.searchTerm = this.searchData.toLowerCase()
    },
    showMore () {
      this.visibleCount += 5
    },
    toggleSub (index) {
      this.activeSub = this.activeSub === index ? null : index
    },
    filterSubMenus3 (id) {
      return this.$store.getters['services/filterSubMenus3'](id).filter(item => item.isHidden === false)
    }
  }
}
</script>

<style scoped>
  .search-box i {
    position: absolute;
    top: 12px;
    right: 6px;
  }

  .main-search {
    width: 100%;
    height: 40px;
    outline: none;
    padding: 0px 25px;
    font-size: 18px;
  }

  .filter-field {
    border-bottom: 1px solid #ababab;
    margin-top: 20px;
  }

  .filter-field select{
    padding: 10px;
     margin-bottom: 20px;
  }

  .news-content {
    margin-bottom: 40px;
  }

  .box {
    margin-top: 10px;
  }

  .box a{
    font-size: 22px;
    color: #006884;
    text-decoration: none;
    font-weight: 700;
    transition: color 0.3s ease;
  }

  .box a:hover {
    color: #d23a3a;
  }

  .news-box {
    margin-top: 5px;
    width: 100%;
    display: flex;
    padding-bottom: 15px;
    line-height: 1.4;
    border-bottom: 1px dashed black;
  }

  .news-box img {
    width: 200px;
    height: 130px;
    margin-right: 12px;
    flex-shrink: 0;
    border: 1px solid #d9d9d9;
    cursor: pointer;
    border-radius: 10px;
    object-fit: cover;
  }

  .info {
    position: relative;
    height: 130px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  .info .drop-down {
    position: absolute;
    width: 100%;
    background-color: white;
    height: 130px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .news-box a:hover {
    color: #d23a3a;
  }

  .news-box #summary {
    font-size: 16px;
    line-height: 1.6;
  }

  .pagination {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 10px 20px;
    padding-right: 0px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 35px;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    /* color: #0298cf; */
    color: #4d4a4a;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
    margin: 0 5px;
    cursor: pointer;
  }

  .more-content {
    display: flex;
    justify-content: flex-end;
  }

  .btn-more {
    margin-top: 10px;
    background: transparent;
    outline: none;
    border: none;
    font-size: 16px;
    color: #3881EE;
    cursor: pointer;
  }

  .info .drop-down a{
    font-weight: 700;
    color: black;
  }

  .info .drop-down a:hover{
    color: #d23a3a;
  }

  #special-title {
    cursor: pointer;
    caret-color: transparent;
    user-select: none;
  }

  .sub-menu {
    padding-top: 10px;
    padding-left: 2px;
    display: grid;
    grid-template-columns: 305px 305px;
    column-gap: 20px;
    row-gap: 17px;
  }

  .sub-link a {
    list-style-type: circle;
    font-size: 15px;
    font-weight: normal;
  }

  @media (max-width: 720px) {
    .box a{
      font-size: 18px;
    }

    .box p{
      font-size: 14px;
    }

    .news-box #summary {
      font-size: 14px;
    }

    .news-box img {
      width: 160px;
    }

    .info {
      -webkit-line-clamp: 6;
    }
  }

  @media (max-width: 485px) {
    .news-box img {
      width: 120px;
      height: 100px;
    }

    .news-box #summary {
      font-size: 12px;
    }

    .info {
      height: 100px;
      -webkit-line-clamp: 5;
    }
  }
</style>
